import { render, staticRenderFns } from "./TillContent.vue?vue&type=template&id=2ff776af&scoped=true"
import script from "./TillContent.vue?vue&type=script&lang=js"
export * from "./TillContent.vue?vue&type=script&lang=js"
import style0 from "./TillContent.vue?vue&type=style&index=0&id=2ff776af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff776af",
  null
  
)

export default component.exports